<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-form ref="formBusca">
            <v-row dense>
              <v-col v-if="$ability.can('Adicionar','Scripts')" cols="12" sm="12" md="12">
                <v-btn
                  outlined
                  color="blue darken-2"
                  rounded
                  dark
                  depressed
                  small
                  @click="$refs.dialogScript.show()"
                >
                  <v-icon left>mdi-plus-circle</v-icon>Adicionar Script
                </v-btn>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <SelectEmpresa
                  :multiple="true"
                  @onChanged="empresas = $event"
                  @onEmpresas="empresasObjects = $event"
                />
              </v-col>

              <v-col cols="12" sm="12" md="3">
                <v-autocomplete v-model="form.tipo" label="Tipo" :items="filters.tipo" />
              </v-col>

              <v-col cols="12" sm="12" md="3">
                <v-checkbox v-model="form.ativo" label="Somente Ativos" color="blue darken-2" />
              </v-col>

              <v-col cols="12">
                <v-row justify="center">
                  <v-btn
                    outlined
                    color="blue darken-2"
                    rounded
                    dark
                    depressed
                    small
                    @click="buscar()"
                  >
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-data-table
            group-by="nomeEmpresa"
            :headers="table.headers"
            :items="table.data"
            :search="table.search"
            sort-field="ordem"
            :sort-desc="true"
          >
            <template v-slot:group.header="{ items }">
              <td colspan="18" class="text-start">
                <v-icon color="blue darken-1" small>mdi-arrow-right-drop-circle</v-icon>
                {{ items[0].nomeEmpresa }}
              </td>
            </template>
            <template v-slot:top>
              <v-row dense>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="table.search"
                    label="Procurar..."
                    prepend-inner-icon="mdi-magnify"
                  />
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.tipo="{ item }">
              <v-icon
                :color="getIconTipo(item.tipo).color"
                :title="item.tipo"
              >{{ getIconTipo(item.tipo).icon }}</v-icon>
            </template>

            <template
              v-slot:item.dataCriacao="{ item }"
            >{{ $functions.formatDateFirebase(item.createdAt.seconds) }}</template>

            <template v-slot:item.ativo="{ item }">
              <v-btn color="transparent" small fab depressed>
                <v-icon
                  :color="item.ativo ? 'green' : 'red'"
                >{{ item.ativo ? 'mdi-check' : 'mdi-close' }}</v-icon>
              </v-btn>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip v-if="$ability.can('Vincular Empresas','Scripts')" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="transparent"
                    small
                    fab
                    v-on="on"
                    depressed
                    @click="$refs.dialogVincular.show(item)"
                  >
                    <v-icon>mdi-link-variant</v-icon>
                  </v-btn>
                </template>
                Vincular Script a Empresas
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="transparent"
                    small
                    v-on="on"
                    fab
                    depressed
                    @click="$refs.dialogViewScript.show(true, item)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                Visualizar
              </v-tooltip>
              <v-tooltip v-if="$ability.can('Editar','Scripts')" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="transparent"
                    small
                    fab
                    v-on="on"
                    depressed
                    @click="$refs.dialogScript.show(true, item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                Editar
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="item.copy"
                    color="transparent"
                    small
                    v-on="on"
                    fab
                    depressed
                    @click="copyClipboard(item)"
                  >
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                Copiar
              </v-tooltip>
            </template>
            <template v-slot:item.conteudo="{item}">
              <span class="d-inline-block text-truncate" style="max-width: 150px;">{{item.conteudo}}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <DialogScript ref="dialogScript" @saved="buscar()" />
    <DialogViewScript ref="dialogViewScript" />
    <DialogVincular @updated="buscar" ref="dialogVincular" />
    <v-snackbar v-model="snackbar" color="success" :timeout="3000" :top="true">
      <span>Conteúdo copiado</span>
      <v-btn text depressed @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import rules from "@/utils/rules";
import { Scripts } from "@/services/materiais";

export default {
  name: "Scripts",

  components: {
    DialogScript: () => import("./components/DialogScripts"),
    DialogViewScript: () => import("./components/DialogViewScript"),
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    DialogVincular: () => import("./components/DialogVincular")
  },

  data() {
    return {
      empresa: null,
      empresasObjects: null,
      snackbar: false,

      filters: {
        tipo: ["", "Whatsapp", "Email", "Telefone", "SMS"]
      },

      form: {
        tipo: "",
        ativo: true
      },

      table: {
        search: "",

        headers: [
          {
            text: "Descrição",
            value: "descricao"
          },
          {
            text: "Conteúdo",
            value: "conteudo"
          },
          {
            text: "Tipo",
            value: "tipo"
          },
          {
            text: "Data Criação",
            value: "dataCriacao"
          },
          {
            text: "Ordem",
            value: "ordem"
          },
          {
            text: "Ativo",
            value: "ativo"
          },
          {
            text: "Actions",
            value: "actions"
          }
        ],

        data: []
      },

      rules: rules
    };
  },

  methods: {
    async buscar() {
      if (this.$refs.formBusca.validate()) {
        try {
          const scripts = await new Scripts().getScripts(
            this.form.tipo,
            this.form.ativo,
            this.empresas,
            this.empresasObjects
          );
          this.table.data = scripts;
        } catch (error) {
          console.error(error);
          this.$toast.error(error);
        }
      }
    },

    getIconTipo(tipo) {
      switch (tipo) {
        case "Whatsapp":
          return { icon: "mdi-whatsapp", color: "green" };
        case "Email":
          return { icon: "mdi-email-outline", color: "blue" };
        case "Telefone":
          return { icon: "mdi-phone", color: "orange" };
        case "SMS":
          return { icon: "mdi-cellphone-message", color: "purple" };
        default:
          return { icon: "mdi-vuetify", color: "blue darken-2" };
      }
    },

    copyClipboard(item) {
      let element = document.createElement("input");
      document.body.appendChild(element);
      element.value = item.conteudo;
      element.select();
      document.execCommand("copy");
      document.body.removeChild(element);
      this.snackbar = true;
    }
  }
};
</script>
